<template>
    <div>
        <!-- name -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Name</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="content.name" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <link-info :link="content.link" :edit="(el) => editChildLink(el)" />

        <!-- create -->
        <div class="field is-grouped" style="margin-top: 1rem;">
            <div class="control">
                <button class="button" @click="cancel()">Cancel</button>
            </div>
            <div class="control">
                <button class="button is-primary" @click="save()">Save</button>
            </div>
        </div>

        <link-edit-modal ref="linkEditModal" />
    </div>
</template>

<script>
import contentService from '../../../../services/content.service';

import LinkEditModal from './link-edit-modal.vue';

export default {
    name: 'content-link-edit',
    components: { LinkEditModal },
    props: {
        content: {
            type: Object,
            required: true
        },
        backRoute: {
            type: Object,
            required: true
        }
    },
    methods: {
        editChildLink(el) {
            this.$refs.linkEditModal.open(el);
        },
        cancel() {
            this.$router.push(this.backRoute);
        },
        async save() {
            await contentService.updateLink(this.content);
            this.$router.push(this.backRoute);
        }
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/common/content/link/content-link-edit.vue